import { render, staticRenderFns } from "./DragDropFileUpload.vue?vue&type=template&id=13f84763&scoped=true&"
import script from "./DragDropFileUpload.vue?vue&type=script&lang=ts&"
export * from "./DragDropFileUpload.vue?vue&type=script&lang=ts&"
import style0 from "./DragDropFileUpload.vue?vue&type=style&index=0&id=13f84763&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f84763",
  null
  
)

export default component.exports